export default "__VITE_ASSET__BFOwXzkm__"